// Stands in for Node's `fs` in the browser bundle. jsmediatags requires it
// for a file reader the browser build never uses; see vite.config.ts.
export default {};
